import { render } from "./Subv.vue?vue&type=template&id=72208472&scoped=true"
import script from "./Subv.vue?vue&type=script&lang=js"
export * from "./Subv.vue?vue&type=script&lang=js"

import "./Subv.vue?vue&type=style&index=0&id=72208472&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72208472"]])

export default __exports__